module.exports = __webpack_public_path__ + "static/media/accounts.1721d5ff.svg";